const ARABIC_DIGITS = '٠١٢٣٤٥٦٧٨٩';
const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹';

const SEARCH_CHUNK_PATTERN = /[0-9]+|[a-z\u0600-\u06FF]+/g;

const toSearchString = (value) => {
    if (value === null || value === undefined) return '';
    if (Array.isArray(value)) return value.map(toSearchString).join(' ');
    if (typeof value === 'object') return Object.values(value).map(toSearchString).join(' ');
    return String(value);
};

export const normalizeSearchText = (value) => (
    toSearchString(value)
        .normalize('NFKC')
        .replace(/[٠-٩]/g, (digit) => ARABIC_DIGITS.indexOf(digit))
        .replace(/[۰-۹]/g, (digit) => PERSIAN_DIGITS.indexOf(digit))
        .replace(/[\u064B-\u065F\u0670\u0640]/g, '')
        .replace(/[أإآٱ]/g, 'ا')
        .replace(/ى/g, 'ي')
        .replace(/ة/g, 'ه')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim()
);

const compactSearchText = (value) => normalizeSearchText(value).replace(/\s+/g, '');

export const getSearchTokens = (query) => {
    const normalizedQuery = normalizeSearchText(query);
    if (!normalizedQuery) return [];

    const whitespaceTokens = normalizedQuery.split(' ').flatMap((token) => {
        const chunks = token.match(SEARCH_CHUNK_PATTERN) || [];
        return chunks.length > 1 ? chunks : [token];
    });
    const chunkTokens = normalizedQuery.match(SEARCH_CHUNK_PATTERN) || [];
    return [...new Set([...whitespaceTokens, ...chunkTokens].filter(Boolean))];
};

export const matchesSearchQuery = (values, query) => {
    const normalizedQuery = normalizeSearchText(query);
    if (!normalizedQuery) return true;

    const searchableText = normalizeSearchText(values);
    if (!searchableText) return false;

    const compactSearchableText = searchableText.replace(/\s+/g, '');
    const compactQuery = compactSearchText(query);

    if (searchableText.includes(normalizedQuery) || compactSearchableText.includes(compactQuery)) {
        return true;
    }

    const queryTokens = getSearchTokens(query);
    return queryTokens.length > 0 && queryTokens.every((token) => (
        searchableText.includes(token) || compactSearchableText.includes(token)
    ));
};
